// extracted by mini-css-extract-plugin
export default {"breadcrub_container":"index_breadcrub_container__zMikT","createdSearch":"index_createdSearch__R7yyj","custom_table":"index_custom_table__9YqjU"};